import React, { Component } from 'react'
import { superAdminLoginRes, superAdminLoginTodo } from "redux/slice/super-admin/login/Login";
import { toast, ToastContainer } from "react-toastify";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { withRouter } from 'react-router-dom';
import { Col, Container, Row, Alert, Label } from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import * as Yup from "yup";
import { AdminLoginRes, AdminLoginTodo } from 'redux/slice/admin/admin-login/Login';
import { AdminSchema } from './Validation';

class AdminLoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spiner: false,
            values: {
                user: '',
                password: ''
            }
        };
    }

    Login_res = () => {
        if (AdminLoginRes && AdminLoginRes.success) {
            toast.success(AdminLoginRes && AdminLoginRes.message, { position: "bottom-right" });
            localStorage.setItem('user_id', AdminLoginRes.data.userId);
            localStorage.setItem('companyId', AdminLoginRes.data.companyId);
            localStorage.setItem('userTypeId', AdminLoginRes.data.userTypeId);
            localStorage.setItem('user_token', AdminLoginRes?.data?.token)
            localStorage.setItem('Image', AdminLoginRes?.data?.Image)
            localStorage.setItem('Username', AdminLoginRes?.data?.Username)
            // localStorage.setItem('userRole', AdminLoginRes.data.is_super_admin === '1' ? 'superadmin' : 'dealer');
            // localStorage.setItem("actions", AdminLoginRes.data.is_super_admin === '1' ? JSON.stringify(routeURL) : JSON.stringify(dealerRouteURL));

            setTimeout(() => {
                this.props.history.push('/admin/dashboard');
          
            }, 1500);
        } else {
            toast.error(AdminLoginRes && AdminLoginRes.message, { position: "bottom-right" });
            this.setState({ spiner: false });
        }
    
    }



    handleSubmit = (values) => {
        this.setState({ spiner: true });
        const { dispatch } = this.props;
        dispatch(AdminLoginTodo(values)).then(() => this.Login_res());
        
    }
    render() {
        return (
            <>
                <div className="mt-4">

                    <Formik
                        initialValues={this.state.values}
                        validationSchema={AdminSchema}
                        onSubmit={this.handleSubmit}
                    >
                        {({
                            values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                            <Form>
                                <div className="mb-3">
                                    <Label for="user" className="form-label">  User Name </Label>
                                    <Field name="user" placeholder="Enter User Name" type="text" className="form-control"
                                        value={values.user}
                                        onChange={handleChange}
                                        onBlur={handleBlur} />
                                    {errors.user && touched.user ? (<span className='text-danger text-start' >{errors.user}</span>) : null}

                                </div>
                                <div className="mb-3">
                                    <div className="float-end">
                                        Forgot password? 
                                    </div>
                                    <Label for="password" className="form-label"> Password</Label>
                                    <Field name="password" placeholder="Enter Password" type="password" autoComplete="true" className="form-control"
                                        value={values.password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.password && touched.password ? (<span className='text-danger text-start' >{errors.password}</span>) : null}
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="remember-check" />
                                    <label className="form-check-label" htmlFor="remember-check" >
                                        Remember me
                                    </label>
                                </div>
                                <div className="mt-3 d-grid">
                                    <button className="btn  btn-block " style={{backgroundColor:'#063763',color:'white'}} type="submit" >
                                        {this.state.spiner ? <> <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                                            <span>Log In....</span> </> : <span>Log In</span>}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </>
        )
    }
}
export default connect()(withRouter(AdminLoginForm));
